import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
const SearchBetter: React.FC<any> = ({ content }) => {
  const showContent = content.contentInfo['section-better'];
  if (!showContent.title) {
    return null;
  }
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{showContent.title}</h2>
      {showContent.desc && <p className={styles.desc}>{showContent.desc}</p>}
      <div className={styles.cardContainer}>
        {showContent.cards.map((item: any) => (
          <div className={styles.card} key={item.title}>
            <Image src={item.imgPath} alt={item.title} width={40} height={40} />
            <h3 className={styles.cardTitle}>{item.title}</h3>
            <p className={styles.cardDesc}>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchBetter;
